
const { REACT_APP_API_URL} = process.env;
// export const API_BASE_URL = REACT_APP_API_URL || 'http://localhost:5000';
export const API_BASE_URL = REACT_APP_API_URL; 
export const LIVE_BASE_URL = REACT_APP_API_URL ? REACT_APP_API_URL?.indexOf('stage') > 0 ? 'https://odds-api.pcstaging.in' : 'https://odds-api.pcstaging.in' : 'https://odds-api.pcstaging.in';
export const ADMIN_BASE_URL = REACT_APP_API_URL ? REACT_APP_API_URL?.indexOf('stage') > 0 ? 'https://odds-api.pcstaging.in' : 'https://odds-api.pcstaging.in' : 'https://odds-api.pcstaging.in';
